<div [style.display]="((!this.showTabMenu && this.layoutSvc.footerButton() == undefined) || !userSvc.isLoggedIn)?'none': 'flex'" class="purple-fit-footer">
  @if(layoutSvc.footerButton() != undefined){
    <div class="purple-fit-footer-button-container">
      <purple-simple-button (click)="layoutSvc.footerButton()!.funct()" class="purple-fit-footer-button"
        [buttonText]="layoutSvc.footerButton()!.text" purpleEditableText 
        [isDisabled]="layoutSvc.footerButton()!.disabled"
        [tranKey]='layoutSvc.footerButton()!.textKey' buttonType="primary">
      </purple-simple-button>
    </div>
  }
  @if(showTabMenu) {
    <purple-fit-tab-menu></purple-fit-tab-menu>
  }
</div>